/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Table } from "semantic-ui-react";
import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { selectCurrentUserApiToken, selectCurrentUserId, selectCurrentUserName, selectSseConnectionId } from "../../slices/currentUser/currentUserSlice";
import { selectViewingOlderVersion } from "../../slices/viewingOlderVersion/viewingOlderVersionSlice";
import { globalLoadingOff, globalLoadingOn } from "../../slices/globalLoading/globalLoadingSlice";
import { fetchOutcomeImportance, importanceUpdated, selectAllImportance, selectOutcomeImportanceStatus } from "../../slices/outcomreImportance/outcomeImpotanceSlice";
import { selectAllOutcomeVariables } from "../../slices/outcomeVariables/outcomeVariablesSlice";
import submitFhirJson from "../../functions/submitFhirJsonAPI";
import updateFhirJson from "../../functions/updateFhirJsonAPI";
import { handleWheel, handleKeyDown } from "../../functions/eventHandlers";
import { fevirPublicationStatusActive } from "../../dictionaries/THOandFHIRValueSets";
import getFhirJson from "../../functions/getFhirJsonAPI";

const handleChange = (name, targetfoi, value, dispatch, ratingDictionary, setChangeAvailableToSaveState) => {
    if (ratingDictionary[targetfoi]) {
        let newRating = JSON.parse(JSON.stringify(ratingDictionary[targetfoi]));
        newRating[name] = value;
        newRating.itemChanged = true;
        dispatch(importanceUpdated(newRating));
        setChangeAvailableToSaveState(true);
    }
};

const updateResourceWithImportanceRatings = (resource, desirabilityCode, desirabilityDisplay,
    percentageValue) => {
    if (resource && !resource.content) {
        resource.content = [
            {
                "type": {
                    "coding": [
                        {
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "outcome-desirability",
                            "display": "Outcome Desirability"
                        }
                    ]
                }
            },
            {
                "type": {
                    "coding": [
                        {
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "relative-importance",
                            "display": "Relative Importance"
                        }
                    ]
                }
            },
            {
                "type": {
                    "coding": [
                        {
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "population",
                            "display": "Population"
                        }
                    ]
                }
            }
        ];
    }
    resource.content = resource.content.map(content => {
        if (content.type?.coding?.length > 0 && content.type.coding[0].code) {
            if (content.type.coding[0].code === "outcome-desirability" || content.type.coding[0].code === "desirability") {
                content.classifier = [
                    {
                        "coding": [
                            {
                                "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/desirability-codesystem",
                                "code": desirabilityCode,
                                "display": desirabilityDisplay
                            }
                        ]
                    }
                ]
            }
            if (content.type.coding[0].code === "relative-importance" && !isNaN(percentageValue)) {
                content.quantity = {
                    "value": percentageValue,
                    "unit": "%",
                    "system": "http://unitsofmeasure.org",
                    "code": "%"
                }
            }
        }
        return content;
    })
    return resource;
};

const DesirabilityEntry = ({ targetfoi, startingValue,
    setChangeAvailableToSaveState }) => {
    const dispatch = useDispatch();
    const ratingResources = useSelector(state => selectAllImportance(state));
    const ratingDictionary = {};
    for (let key in ratingResources) {
        ratingDictionary[ratingResources[key].id] = ratingResources[key];
    }

    return <div>
        {(ratingDictionary && Object.keys(ratingDictionary).length > 0) &&
            <>
                {/*
      TO DO THIS DOESN'T WORK YET, FOR FUTURE
      <YesNoRadioCheckBoxSwitch elementName={"desirabilityCode"} labelElementName={"desirabilityDisplay"} thin={true} togglable={true} boxes={true} alternativeValues={["desirable", "undesirable"]} alternativeLabels={["Desirable", "Undesirable"]} parentElement={targetfoi} startingValue={startingValue || ""} setter={setResourceState} setChangeAvailableToSaveState={setChangeAvailableToSaveState} />
      */}
                <RadioGroup row aria-label="desirability" name="desirability"
                    value={startingValue}
                    onChange={(e) => {
                        handleChange("desirabilityCode", targetfoi, e.target.value.toLowerCase(),
                            dispatch, ratingDictionary, setChangeAvailableToSaveState);
                        handleChange("desirabilityDisplay", targetfoi, e.target.value,
                            dispatch, ratingDictionary, setChangeAvailableToSaveState);
                    }}>
                    <FormControlLabel
                        value="Desirable"
                        control={<Radio color="primary" />}
                        name="radio-button-control"
                        color="default"
                        inputprops={{ 'aria-label': 'Desirable' }}
                        labelPlacement="top"
                        label={<p style={{ textAlign: 'center' }}>Desirable</p>}
                    />
                    <FormControlLabel
                        value="Undesirable"
                        control={<Radio color="primary" />}
                        color="default"
                        name="radio-button-control"
                        inputprops={{ 'aria-label': 'Undesirable' }}
                        labelPlacement="top"
                        label={<p style={{ textAlign: 'center' }}>Undesirable</p>}
                    />
                </RadioGroup>
            </>}
    </div>
};

const QuantityValueEntry = ({ elementName, fieldLabel, targetfoi, startingValue,
    setChangeAvailableToSaveState }) => {
    const dispatch = useDispatch();
    const ratingResources = useSelector(state => selectAllImportance(state));
    const ratingDictionary = {};
    for (let key in ratingResources) {
        ratingDictionary[ratingResources[key].id] = ratingResources[key];
    }

    return <div>
        {(ratingDictionary && Object.keys(ratingDictionary).length > 0) &&
            <>
                <TextField style={{ width: "100%", marginTop: "16px", maxWidth: "150px" }}
                    className="inputField" type='number' inputMode='numeric' autoComplete='off'
                    label={fieldLabel} size="small" variant='outlined'
                    value={startingValue}
                    onWheel={handleWheel}
                    onKeyDown={handleKeyDown}
                    onChange={(e) => {
                        handleChange(elementName, targetfoi, parseFloat(e.target.value || 0),
                            dispatch, ratingDictionary, setChangeAvailableToSaveState)
                    }} />
            </>}
    </div>
};

const loadRatingDictionary = async (dispatch, outcomeVariables, subject) => {
    dispatch(globalLoadingOn()); //TODO unless await can be added inside dispatch, the globalLoading on/off may not work here
    if (outcomeVariables && Object.keys(outcomeVariables).length > 0) {
        let targetResources = Object.keys(outcomeVariables).map(foi => { return outcomeVariables[foi] });
        let body = {
            targetResources: targetResources,
            subject: subject
        }
        dispatch(fetchOutcomeImportance(body));
    }
    dispatch(globalLoadingOff());
};

const RateRelativeImportanceTable = ({ setChangeAvailableToSaveState, subject }) => {

    const dispatch = useDispatch();
    const ratingstatus = useSelector(selectOutcomeImportanceStatus);
    const outcomeVariables = useSelector(state => selectAllOutcomeVariables(state));
    const ratingResources = useSelector(state => selectAllImportance(state));
    const ratingDictionary = {};
    for (let key in ratingResources) {
        ratingDictionary[ratingResources[key].id] = ratingResources[key];
    }

    useEffect(() => {
        if (outcomeVariables && Object.keys(outcomeVariables).length > 0 && ratingstatus !== "succeeded") {
            loadRatingDictionary(dispatch, outcomeVariables, subject);
        }
    }, [outcomeVariables])

    return <>
        {(ratingDictionary && Object.keys(ratingDictionary).length > 0) ?
            <Table className='viewmyworktable'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>
                            <span>Outcome</span>
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            <span>Desirability</span>
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            <span>Relative Importance (as %)</span>
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {(outcomeVariables && Object.keys(outcomeVariables).length > 0) &&
                        Object.keys(outcomeVariables).map((targetFoi) => {
                            let item = outcomeVariables[targetFoi];
                            return <Table.Row key={targetFoi}>
                                <Table.Cell>
                                    <a href={item.id && "/resources/EvidenceVariable/" + item.id.toString()}
                                        target="_blank" rel="noopener noreferrer" >
                                        {item.shortTitle || item.title}
                                    </a>
                                </Table.Cell>
                                <Table.Cell>
                                    <DesirabilityEntry
                                        targetfoi={item.id}
                                        startingValue={ratingDictionary[item.id]?.desirabilityDisplay || ""}
                                        setChangeAvailableToSaveState={setChangeAvailableToSaveState} />
                                </Table.Cell>
                                <Table.Cell>
                                    <QuantityValueEntry elementName='percentageValue'
                                        targetfoi={item.id}
                                        fieldLabel={'Relative Importance (%)'}
                                        startingValue={ratingDictionary[item.id]?.percentageValue?.toString() || ""}
                                        setChangeAvailableToSaveState={setChangeAvailableToSaveState} />
                                </Table.Cell>
                            </Table.Row>
                        })}
                </Table.Body>
            </Table>
            :
            <h1>Need to reload ratingDictionary</h1>
        }</>
}

const saveChanges = async (dispatch, setSaveChangesState, ratingDictionary,
    apiToken, connectionId, userName, setChangeAvailableToSaveState, setRateRelativeImportanceModalState,
    setTriggerReloadState, subject, userId) => {
    for (const key in ratingDictionary) {
        const item = JSON.parse(JSON.stringify(ratingDictionary[key]));
        if (item.itemChanged) {
            if (item.exists) {
                if (!item.resourceJson) {
                    alert("Problem updating Rating for FOI " + key);
                } else {
                    let updatedResource = updateResourceWithImportanceRatings(item.resourceJson, item.desirabilityCode, item.desirabilityDisplay, item.percentageValue);
                    let response = await updateFhirJson(item.importanceFoi, updatedResource,
                        updatedResource.title, apiToken, connectionId, "active", key, 'SummaryOfFindingsAuthoringTool')
                    if (response?.success) {
                        let newestResourceJson = await getFhirJson(item.importanceFoi, null, apiToken, false);
                        if (newestResourceJson) {
                            item.resourceJson = newestResourceJson;
                        }
                        console.log("successful updating of importance rating FOI " + item.importanceFoi);
                    } else {
                        alert("Problem updating Rating for FOI " + key);
                    }
                    item["exists"] = true;
                    item["itemChanged"] = false;
                    dispatch(importanceUpdated(item));
                }
            }
            if (!item.exists) {
                let forWhom = userName;
                let forWhomReference = {
                    "identifier": {
                        "type": {
                            "coding": [{
                                "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
                                "code": "ACSN", "display": "Accession ID"
                            }]
                        }, "value": userId
                    }
                }
                forWhom = subject?.display || "General Population";
                forWhomReference = subject || {
                    "reference": "Group/414027",
                    "type": "Group",
                    "display": "General Population (414027)"
                };
                let newRating = {
                    "resourceType": "ArtifactAssessment",
                    "meta": {
                        "profile": [
                            "http://hl7.org/fhir/uv/ebm/StructureDefinition/outcome-importance"
                        ]
                    },
                    "extension": [
                        {
                            "url": "http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-publication-status",
                            "valueCodeableConcept": fevirPublicationStatusActive
                        },
                        {
                            "url": "http://hl7.org/fhir/StructureDefinition/artifact-author",
                            "valueContactDetail": {
                                "name": userName
                            }
                        }
                    ],
                    "title": "Outcome Importance Rating of " + item.targettitleTrimmed + "  for " + forWhom,
                    "artifactReference": {
                        "reference": "EvidenceVariable/" + key,
                        "type": "EvidenceVariable",
                        "display": item.targettitle
                    },
                    "content": [
                        {
                            "type": {
                                "coding": [
                                    {
                                        "system": "https://fevir.net/resources/CodeSystem/179423",
                                        "code": "outcome-desirability",
                                        "display": "Outcome Desirability"
                                    }
                                ]
                            },
                            "classifier": [
                                {
                                    "coding": [
                                        {
                                            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/desirability-codesystem",
                                            "code": item.desirabilityCode,
                                            "display": item.desirabilityDisplay
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "type": {
                                "coding": [
                                    {
                                        "system": "https://fevir.net/resources/CodeSystem/179423",
                                        "code": "relative-importance",
                                        "display": "Relative Importance"
                                    }
                                ]
                            },
                            "quantity": {
                                "value": item.percentageValue,
                                "unit": "%",
                                "system": "http://unitsofmeasure.org",
                                "code": "%"
                            }
                        },
                        {
                            "type": {
                                "coding": [
                                    {
                                        "system": "https://fevir.net/resources/CodeSystem/179423",
                                        "code": "population",
                                        "display": "Population"
                                    }
                                ]
                            },
                            "relatesTo": [
                                {
                                    "type": "supports",
                                    "targetReference": forWhomReference
                                }
                            ]
                        }
                    ]
                };
                if (isNaN(item.percentageValue)) {
                    delete newRating.content[1].quantity;
                }
                let response = await submitFhirJson(newRating, newRating.title, apiToken,
                    "active", key, 'SummaryOfFindingsAuthoringTool', false);
                if (response?.success) {
                    console.log("successful submission for " + response.formstateid)
                } else {
                    alert("Problem submitting Rating for FOI " + key);
                }
                item["exists"] = true;
                item["importanceFoi"] = response.formstateid;
                item["itemChanged"] = false;
                item["importanceReference"] = {
                    "reference": "ArtifactAssessment/" + response.formstateid,
                    "type": "ArtifactAssessment",
                    "display": newRating.title
                };
                item["importanceTitle"] = newRating.title;
                item["resourceJson"] = newRating;
                dispatch(importanceUpdated(item));
            }
        }
    }
    console.log("setTriggerReloadState to true from RateRelativeImportance");
    setTriggerReloadState(true);
    setSaveChangesState(false);
    setChangeAvailableToSaveState(false);
    setRateRelativeImportanceModalState(prevState => { return { ...prevState, modalOpen: false }; });
}

const RateRelativeImportanceModal = ({ rateRelativeImportanceModalState, setRateRelativeImportanceModalState,
    setTriggerReloadState, subject, setImportanceRatingsChangedState }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const connectionId = useSelector(selectSseConnectionId);
    const userName = useSelector(selectCurrentUserName);
    const userId = useSelector(selectCurrentUserId);
    const dispatch = useDispatch();
    const ratingResources = useSelector(state => selectAllImportance(state));
    const ratingDictionary = {};
    for (let key in ratingResources) {
        ratingDictionary[ratingResources[key].id] = ratingResources[key];
    }

    const [saveChangesState, setSaveChangesState] = useState(false);
    const [changeAvailableToSaveState, setChangeAvailableToSaveState] = useState(false);

    useEffect(() => {
        if (saveChangesState === true && ratingDictionary && Object.keys(ratingDictionary).length > 0) {
            saveChanges(dispatch, setSaveChangesState, ratingDictionary, apiToken, connectionId, userName,
                setChangeAvailableToSaveState, setRateRelativeImportanceModalState, setTriggerReloadState,
                subject, userId);
            if (setImportanceRatingsChangedState) {
                setImportanceRatingsChangedState(true);
            }
        }
    }, [saveChangesState]);

    let modalContent = <div style={{
        paddingTop: "0px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        <span style={{
            position: "absolute", backgroundColor: "#FFFFFF", width: "calc(90vw - 38px)", zIndex: 100,
            paddingTop: "6px", paddingBottom: "6px"
        }} >
            <Button style={{
                color: changeAvailableToSaveState ? "#FFFFFF" : "#000000",
                width: "230px", float: "left"
            }}
                className="formButton" disabled={saveChangesState}
                content="Save Changes" positive={changeAvailableToSaveState}
                onClick={() => {
                    setSaveChangesState(true);
                }}
            />
            &nbsp;&nbsp;&nbsp;
            <Button style={{ color: "#000000", width: "180px", float: "right" }}
                className="formButton"
                content="Close Window"
                onClick={() => {
                    setRateRelativeImportanceModalState(prevState => { return { ...prevState, modalOpen: false }; });
                }}
            />
        </span>
        <br /><br /><br />
        <div className='tableFixHead'>
            <RateRelativeImportanceTable
                setChangeAvailableToSaveState={setChangeAvailableToSaveState}
                subject={subject} />
        </div>
        <br /><br />
    </div>;

    return (
        <Modal
            style={{ padding: "0px", margin: "0px" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={rateRelativeImportanceModalState?.modalOpen}
            centered={false}
            content={modalContent}
            className="viewmywork"
        />
    )
}

const RateRelativeImportance = ({ setTriggerReloadState, subject, setImportanceRatingsChangedState }) => {
    const apiToken = useSelector(selectCurrentUserApiToken);
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));

    const [rateRelativeImportanceModalState, setRateRelativeImportanceModalState] = useState({ "modalOpen": false });

    return <>
        {rateRelativeImportanceModalState.modalOpen &&
            <RateRelativeImportanceModal
                subject={subject} setImportanceRatingsChangedState={setImportanceRatingsChangedState}
                rateRelativeImportanceModalState={rateRelativeImportanceModalState}
                setRateRelativeImportanceModalState={setRateRelativeImportanceModalState}
                setTriggerReloadState={setTriggerReloadState} />}
        <span>
            <Button className="formButton" style={{ color: "#000000", width: "220px" }}
                content="Rate Relative Importance"
                onClick={() => {
                    if (apiToken) {
                        setRateRelativeImportanceModalState({ "modalOpen": true });
                    } else {
                        alert("Please login to use this function.");
                    }
                }}
                disabled={viewingOlderVersion}
            />
            &nbsp;&nbsp;&nbsp;
            <>
                Select Desirable or Undesirable and rate your relative importance of each outcome (from 0 for no importance to 100 to represent the reference value of importance).
            </>
        </span>
    </>
};

export default RateRelativeImportance;